/*
 * @Author: cc
 * @Date: 2019-12-16 21:51:31
 * @LastEditTime: 2021-05-11 15:31:46
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\util\trsAudioVideoUpload\videoDraftUpload\videoDraft.js
 * @Description: 视频稿插入视频部分整合
 */
'use strict';
angular.module('trsAudioVideoDraftModule', []).directive('trsUploadForXjVideoDraft', [
    '$q',
    '$timeout',
    '$state',
    'modalDialog',
    'editCenUploadVideoForXjService',
    'localStorageService',
    'editingCenterService',
    'mrApiService',
    '$sessionStorage',
    'publicToolService',
    'globleParamsSet',
    function ($q, $timeout, $state, modalDialog, editCenUploadVideoForXjService, localStorageService, editingCenterService, mrApiService, $sessionStorage, publicToolService, globleParamsSet) {
        return {
            // name: '',
            // priority: 1,
            // terminal: true,
            scope: {
                list: '=',
                storageType: '@', // 视频上传缓存类型
                metadata: '@', // 稿件编辑页id参数
                preview: '@', // 是否查看页
                limitObj: '=', // 视频上传限制需求三个参数size(上传视频大小限制,单位Mb),duration(上传视频时长限制),name(上传视频名称中文，！！！！必须传)

            },
            restrict: 'EA', // E = Element, A = Attribute, C = Class, M = Comment
            templateUrl: './components/util/trsAudioVideoUpload/videoDraftUpload/videoDraft.html',
            replace: true,
            link: function ($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.status = {
                        complete: 100, // 上传完成
                        unit: 1024, // 单位
                        burst: 5, // 分片
                        division: 20, // 分片间隔数，超过该数认为是大视频
                        showCheckList: [false, false],
                        machineStatus: null, // 0 审核中 -1 失败 1 成功
                        machineFlag: true,
                        timerToStatus: '',
                        errMsg: [],
                        toolBarDirect: 'right',
                        mediaName: '',
                        medialists: {
                            'fusionnews': '个人稿库',
                            'fusionvideo': '个人稿库', // iwo
                            'newspapertext': '纸媒', // 纸媒
                            'websitenews': '网站',
                            'websitevideo': '网站',
                            'appnews': '客户端',
                            'appvideo': '客户端', // 客户端
                            'weiboedit': '微博', // 微博
                            'trillnews': '抖音',// 抖音
                            'baijiahaonews': '百家号',
                            'baijiahaovideo': '百家号', // 百家号
                            'qiehaonews': '企鹅号',
                            'qiehaovideo': '企鹅号', // 企鹅号
                            'toutiaohaonews': '头条号',
                            'toutiaohaovideo': '头条号', // 头条号
                        },
                        isShowCheckSuccess: false,
                        isPreview: $state.current.name.includes('Preview') || $state.current.name.includes('preview'), // 是否是预览页面,如果是预览页面没有视频整体不显示
                        videoStatus: '', // 视频状态包括转码、审查、上传等多种状态，都由本字段表示
                        damageVideo: false
                    };
                    $scope.uploader = {
                        example: '',
                        canNotPlay: false, // video标签只能播放MP4、WebM、Ogg的格式
                        progress: 0,
                        fastVideoTimer: '',
                        fastVideoInfo: {}, // 视频快编信息
                        speed: '0KB/S', // 上传速率
                        surplusTime: '', // 剩余时间
                        uploaderOptions: angular.extend({}, editCenUploadVideoForXjService.singleVideoOption), // 上传配置项
                    };
                    if ($scope.limitObj && $scope.limitObj.accept) {
                        $scope.uploader.uploaderOptions.accept = $scope.limitObj.accept; // 如果渠道有文件限制，使用渠道内的替代公用
                    }
                    publicToolService.getModeconfiguration('avUploader').then((config) => {
                        $scope.status.avUploadrOption = config;
                    });
                }

                /**
                 * [initData description] 初始化数据
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    if ($state.params[$scope.metadata]) {
                        // 编辑稿件时检查视频，新建稿件时检查是不是融合编辑器来的
                        examineVideo();
                        // initMachineReview();
                    } else {
                        if ($scope.list && $scope.list.VIDEOREL && $scope.list.VIDEOREL.length) {
                            if ($scope.list.VIDEOREL[0].PLATFORMFLAG === 'BDVideoObject') {
                                // 由本地上传的音视频进行查询
                                getVideoInfo().then((data) => {
                                    // 初始化ckplayer
                                });
                            } else {
                                // 文字转音频的不再查询一次
                                $scope.list.videoStatus = '转码完成';
                            }
                        }
                    }
                    $scope.$on('$destroy', function () {
                        $timeout.cancel($scope.uploader.fastVideoTimer);
                    });
                }

                /**
                 * [startInterval description]设置定时器
                 * @return {[type]} [description]
                 */
                function startInterval() {
                    $timeout.cancel($scope.uploader.fastVideoTimer);
                    beginTimeout();
                }

                /**
                 * [limitVideo description] 限制视频类型或者大小
                 * @param   {[object]}  data  [data description] 获取的视频信息
                 * @return  {[promise]}       [return description]
                 */
                function limitVideo(data) {
                    var deffer = $q.defer();
                    if ($scope.limitObj && $scope.limitObj.name) {
                        if ($scope.limitObj.size && data.size > $scope.status.unit * $scope.status.unit * $scope.limitObj.size) {
                            modalDialog.alertType(
                                '视频复制失败',
                                $scope.limitObj.name + '渠道上传视频上限' + $scope.limitObj.size + 'M',
                                'error',
                                false,
                            );
                            $scope.deleteVideo();
                            deffer.reject();
                        } else if ($scope.limitObj.duration && data.duration > 60 * 1000 * $scope.limitObj.duration) {
                            modalDialog.alertType(
                                '视频复制失败',
                                $scope.limitObj.name + '渠道上传视频时间' + $scope.limitObj.duration + '分钟内',
                                'error',
                                false,
                            );
                            $scope.deleteVideo();
                            deffer.reject();
                        } else {
                            deffer.resolve(data);
                        }
                    } else {
                        deffer.resolve(data);
                    }
                    return deffer.promise;
                }

                /**
                 * [beginTimeout description]开始计时
                 * @return  {[type]}  [return description]
                 */
                function beginTimeout() {
                    $scope.uploader.fastVideoTimer = $timeout(function () {
                        getVideoInfo().then(function () {

                        }, function () {
                            beginTimeout();
                        });
                    }, editCenUploadVideoForXjService.videoPollInterval);
                }

                /**
                 * [examineVideo description]视频检查
                 * @return {[type]} [description]
                 */
                function examineVideo() {
                    var videoInfo = localStorageService.get('videoUploadInfo');
                    editCenUploadVideoForXjService.exampleVideo(videoInfo, $scope.list, $state.params[$scope.metadata], $scope.storageType).then(
                        function (data) {
                            $scope.list.VIDEOREL[0].AUDIOVIDEOID = data[0]; // 再次回写ID
                            getVideoInfo();
                        },
                        function () {
                            getVideoInfo();
                        },
                    );
                }

                /**
                 * [getVideoInfo description]获得视频详情
                 * @return {[type]} [description]
                 */
                function getVideoInfo() {
                    var deffer = $q.defer();
                    editCenUploadVideoForXjService.getVideoMark($scope.list.VIDEOREL[0]).then(
                        function (data) {
                            limitVideo(data).then(() => {
                                $scope.uploader.fastVideoInfo = data;
                                $scope.list.videoStatus = editCenUploadVideoForXjService.videoDraftStatus[data.status];
                                if ($scope.list.videoStatus === '转码中' || $scope.list.videoStatus === '快编中') {
                                    if (!$scope.uploader.fastVideoTimer) {
                                        startInterval();
                                    }
                                } else {
                                    $scope.list.VIDEOREL[0].URL = data.videoUrl; // 回填URL
                                    $scope.list.VIDEOREL[0].RESOURCEURL = data.resourceUrl; // 回填源码地址
                                    // 封面图用自己的
                                    $scope.list.VIDEOREL[0].ThumbImg = $scope.list.VIDEOREL[0].THUMBIMG || data.ThumbImg;
                                    $timeout.cancel($scope.uploader.fastVideoTimer);
                                    deffer.resolve();
                                }
                                deffer.reject();
                            });

                        },
                        function () {
                            modalDialog.alertType('转码失败', '请重新上传', 'warning', false);
                            $scope.deleteVideo();
                        },
                    );
                    return deffer.promise;
                }

                /**
                 * [uploadTest description]视频上传
                 * @return {[type]} [description]
                 */
                $scope.upload = function () {
                    let options = {
                        resourceType: '2',
                        isMulti: false,
                        isShowVideoLink: false,
                    };
                    editingCenterService.mediaSelector(options).then(function (result) {
                        for (var i = 0; i < result.list.length; i++) {
                            var file = result.list[i];
                            $scope.status.machineStatus = file.resourcestatus;
                            if (file.resourcestatus === 10) {
                                uploadAsync(file);
                                if (file.type !== 'video/mp4') {
                                    $scope.uploader.canNotPlay = true;
                                }
                            } else if (file.resourcestatus !== 10) {
                                $scope.list.videoStatus = '转码完成';
                                $scope.list.VIDEOREL.push({
                                    AUDIOVIDEOID: file.videoid,
                                    URL: file.useableurl || file.path,
                                    REMARKS: '',
                                    PLATFORMFLAG: 'BDVideoObject',
                                    RESOURCEURL: file.resourceurl,
                                    ThumbImg: file.thumbimg,
                                    relationId: file.relationid,
                                    meiziId: file.resourceid,
                                    resourcesize: file.resourcesize,
                                    resourceduration: file.resourceduration,
                                    fmt: file.fmt,
                                });

                            }
                            storgeVideoInfo({ datas: file });
                        }
                    });
                };

                /**
                 * [deleteVideo description] 删除视频预览
                 * @return {[type]} [description]
                 */
                $scope.deleteVideo = function () {
                    $scope.status.showCheckList = [false, false];
                    $scope.list.videoStatus = '';
                    $scope.status.damageVideo = false;
                    if ($scope.uploader.fastVideoTimer) {
                        // 避免存在失败的情况还在轮训
                        $timeout.cancel($scope.uploader.fastVideoTimer);
                    }
                    $scope.list.VIDEOREL = [];
                };

                /**
                 * [editVideo description]快编视频
                 * @return {[type]} [description]
                 */
                $scope.fastEditVideo = function () {
                    $scope.status.damageVideo = false;
                    $scope.loadingPromise = editCenUploadVideoForXjService.editVideo($scope.list).then(function (data) {
                        startInterval();
                        storgeVideoInfo(data); // 快编后等于又一次上传保存
                        $scope.list.VIDEOREL[0].AUDIOVIDEOID = data.datas.videoid; // 回写ID
                        getVideoInfo();
                        window.open(data.datas.qediturl); // 打开快编页面
                    });
                };

                /**
                 * [modifyCover description]修改抖音封面图
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.modifyCover = function () {
                    var options = {
                        isMultiple: false,
                    }
                    globleParamsSet.getTokenService($sessionStorage.get('curUserInfo').TENANTID).then(
                        function (tokenInfo) {
                            var params = {
                                tenantId: $sessionStorage.get('curUserInfo').TENANTID,
                                videoId: $scope.list.VIDEOREL[0].AUDIOVIDEOID,
                                userId: tokenInfo.token
                            }
                            // var requestUrl = '/bigdata/tv/transfer/video/detail';
                            publicToolService.pictureSelector(options, params).then(function (data) {
                                // 把选择好了的封面替换掉
                                $scope.list.VIDEOREL[0].ThumbImg = data[0].pic_url;
                            });
                        }
                    );
                };

                /**
                 * [cancelEditVideo description]取消快编
                 * @return {[type]} [description]
                 */
                $scope.cancelEditVideo = function () {
                    $scope.loadingPromise = editCenUploadVideoForXjService.cancelEditVideo($scope.list).then(function (data) {
                        $scope.list.VIDEOREL[0].AUDIOVIDEOID = data.videoId; // 回写ID
                        $scope.list.VIDEOREL[0].URL = data.videoUrl;
                        $scope.list.videoStatus = editCenUploadVideoForXjService.videoDraftStatus[data.status];
                        $timeout.cancel($scope.uploader.fastVideoTimer);
                    });
                };

                /**
                 * [storgeVideoInfo description]存储当前稿件视频信息
                 * @param   {[type]}  videoInfo  [videoInfo description]
                 * @return  {[type]}             [return description]
                 */
                function storgeVideoInfo(videoInfo) {
                    if (!$state.params[$scope.metadata]) {
                        // 只有编辑页才存储
                        return;
                    }
                    // 获取整体对象
                    var sendObj = localStorageService.get('videoUploadInfo') || {};
                    // 获取对象
                    var storage = localStorageService.get('videoUploadInfo')
                        ? localStorageService.get('videoUploadInfo')[$scope.storageType] || {}
                        : {};
                    storage[$state.params[$scope.metadata] || 0] = [videoInfo.datas.videoid]; // 不保存的话存储状态
                    sendObj[$scope.storageType] = storage;
                    localStorageService.set('videoUploadInfo', sendObj); // 记录上传后的视频信息
                }

                /**
                 * [uploadAsync description]上传后的异步操作
                 *
                 * @param  {[obj]} videoInfo [description]上传的文件信息
                 * @return {[type]}     [description]
                 */
                function uploadAsync(videoInfo) {
                    $scope.list.VIDEOREL = [];
                    $scope.uploader.progress = 0;
                    $timeout(function () {
                        $scope.list.videoStatus = '转码中';
                        $scope.list.VIDEOREL.push({
                            AUDIOVIDEOID: videoInfo.videoid,
                            URL: videoInfo.previewurl || videoInfo.path,
                            REMARKS: '',
                            PLATFORMFLAG: 'BDVideoObject',
                            RESOURCEURL: videoInfo.resourceurl,
                            ThumbImg: videoInfo.thumbimg,
                            relationId: videoInfo.relationid,
                            meiziId: videoInfo.resourceid,
                        });
                        $scope.status.showCheckList = [false, false];
                        getErrorMsg();
                    });
                    startInterval(); // 上传成功后就轮训
                }

                /**
                 * [initMachineReview description]初始化智能机审
                 * @return  {[type]}     [return description]
                 */
                function initMachineReview() {
                    var relationId = $scope.list.VIDEOREL[0].RELATIONID || $scope.list.VIDEOREL[0].relationId;
                    if (!relationId) {
                        return;
                    }
                    mrApiService.getMaterialDetail({
                        mrType: 'personal',
                        mainResourceType: 2,
                        relationId: $scope.list.VIDEOREL[0].RELATIONID || $scope.list.VIDEOREL[0].relationId,
                    }).then(function (data) {
                        $scope.status.machineStatus = data.datas[0].checkstatus;
                        $scope.status.machineFlag = true;
                        if (data.datas[0].checkstatus == 0) {
                            setTimerToStatus();
                        } else if (data.datas[0].checkstatus == 1) {
                            $timeout.cancel($scope.status.timerToStatus);
                        } else {
                            $timeout.cancel($scope.status.timerToStatus);
                            var param = {
                                resourceid: $scope.list.VIDEOREL[0].MEIZIID,
                                tenantId: $sessionStorage.get('curUserInfo').TENANTID,
                                userName: $sessionStorage.get('curUserInfo').USERNAME,
                            };
                            mrApiService.getErrorMsg(param).then(function (data) {
                                if (data.code === '200') {
                                    $scope.status.errMsg = data.datas;
                                    $scope.status.mediaName = $scope.status.medialists[$state.current.name];
                                }
                            });
                        }

                    });
                }

                /**
                 * [machineReview description]智能机审
                 * @return  {[type]}     [return description]
                 */
                $scope.machineReview = function () {
                    $scope.status.machineStatus = 0;
                    getMRresult();
                };

                /**
                 * [getMRresult description]点击智能机审
                 * @return  {[type]}     [return description]
                 */
                function getMRresult() {
                    let relationId = $scope.list.VIDEOREL[0].RELATIONID || $scope.list.VIDEOREL[0].relationId;
                    if (!relationId) {
                        return;
                    }
                    mrApiService
                        .requestCensor({
                            mrType: 'personal',
                            mainResourceType: 2,
                            relationId: relationId,
                        }).then(function (data) {
                            if (data.code == 200) {
                                setTimerToStatus();
                            } else {
                                modalDialog.alertType('', data.msg, 'error', false);
                            }
                        });
                }

                /**
                 * [setTimerToStatus description] 定时器查询机审状态
                 * @return  {[type]}     [return description]
                 */
                function setTimerToStatus() {
                    $timeout.cancel($scope.status.timerToStatus);
                    $scope.status.machineFlag = false;
                    $scope.status.timerToStatus = $timeout(function () {
                        initMachineReview();
                    }, editCenUploadVideoForXjService.videoPollInterval);
                }

                /**
                 * [requestData description] 回调刷新数据
                 * @return  {[type]}     [return description]
                 */
                $scope.requestData = function () {
                    $scope.status.machineFlag = true;
                };

                /**
                 * [getErrorMsg description] 审核不通过获取错误信息
                 * @return  {[type]}     [return description]
                 */
                function getErrorMsg() {
                    var param = {
                        resourceid: $scope.list.VIDEOREL[0].meiziId,
                        tenantId: $sessionStorage.get('curUserInfo').TENANTID,
                        userName: $sessionStorage.get('curUserInfo').USERNAME,
                    };
                    mrApiService.getErrorMsg(param).then(function (data) {
                        if (data.code === '200') {
                            $scope.status.errMsg = data.datas;
                            $scope.status.mediaName = $scope.status.medialists[$state.current.name];
                        }
                    });
                }
                /**
                 * [dealErrorVideo description] 处理错误视频
                 * @return  {[type]}  [return description]
                 */
                $scope.dealErrorVideo = function () {
                    $timeout(() => {
                        $scope.status.damageVideo = true;
                    });
                };
            },
        };
    },
]);
